<template>
  <div class="common-panel set-choose-input-voice-root">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="panel-content">
      <!-- 非答题模式套题题干播放按钮 -->
      <div class="panel-content-options">
        <ButtonTool
          :type="isExamMode ? 'none' : 'play'"
          @click.native="clickPlayTopVoice(true)"
          v-show="topPlayStatus == 'play'"
        ></ButtonTool>
        <ButtonTool
          v-show="topPlayStatus == 'pause' && !isExamMode"
          @click.native="clickPauseTopVoice()"
          type="pause"
          slot="content"
        ></ButtonTool>
      </div>
      <!-- 套题内容 -->
      <div class="panel-content-details">
        <div class="question-item" v-for="(item, itemIndex) in newQuestionList" :key="itemIndex">
          <!-- 考试题目 分为 填空和选择，填空的question_type=='tk';选择的question_type为空 -->

          <!-- 题号 || 题号+填空题 -->
          <div class="question-item-stem">
            <div class="stem-index-yellow">
              {{ item.is_example ? $('hsk_example') : item.index }}
            </div>
            <div
              v-for="(stemConent, contentNum) in item.screen_text"
              :key="item.index + contentNum"
            >
              <p v-if="stemConent.type == 'text'" class="stem-text">
                {{ stemConent.content }}
              </p>
            </div>

            <!-- 小题题干的播放按钮 -->
            <div class="stem-content" v-show="!isExamMode">
              <img
                v-show="!isExamMode && (item.playStatus == 'play' || !item.playStatus)"
                @click="clickPlayVoice(item, true)"
                :src="iconPlay('play')"
                alt=""
              />

              <img
                v-if="!isExamMode && item.playStatus == 'pause'"
                @click="clickPauseVoice(item)"
                :src="iconPlay('pause')"
                alt=""
              />
            </div>
            <!-- 填空题渲染 -->
            <div v-if="item.question_type == 'tk'" class="tk-con">
              <div v-for="(tkItem, index) in item?.tkContentArr" :key="index + 'tkCOntent'">
                <p v-if="tkItem.type == 'text'" class="tk-text">{{ tkItem.val }}</p>
                <template v-else-if="tkItem.type == 'input'">
                  <!-- input绑定原数组值层级太深，无法响应 -->
                  <el-input
                    v-if="isExamMode"
                    v-model="inputArr[tkItem.count]"
                    :placeholder="$t('hsk_input_type_here')"
                    maxlength="15"
                    clearable
                    class="tk-input"
                    @change="tkInputChange($event, item, itemIndex, tkItem)"
                  >
                  </el-input>
                  <div
                    v-if="!isExamMode"
                    :class="[
                      'tk-input-result',
                      {
                        tkSuccess: !isExamMode && item.scores !== null && item.judge == 1,
                        tkError: !isExamMode && item.scores !== null && item.judge == 0,
                      },
                    ]"
                  >
                    {{ inputArr[tkItem.count] }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- 选择题的选项渲染 -->
          <div class="question-item-flex" v-if="item.question_type != 'tk'">
            <div
              v-for="option in item.answers"
              :key="`${item.index}_${option.index}`"
              :class="[
                'item-answer',
                {
                  selected: option.selected,
                  success: !isExamMode && option.correct,
                  error: !isExamMode && option.selected && !option.correct,
                },
              ]"
              :data-correct="option.correct ? 1 : 0"
              @click="clickQuestionChoice($event, item, option, itemIndex)"
            >
              <!-- option.selected{{ option.selected }} -->
              <div class="item-key">{{ option.flag }}</div>
              <p>{{ option.content }}</p>
            </div>
          </div>
          <!-- 答案/结果 非答题模式，并且不是例题的时候显示；-->
          <template v-if="!isExamMode && !currItem.is_example">
            <div v-if="item.question_type == 'tk'">
              <!-- <div class="mark-score-con">
                {{ $t('evaluate_common_total_score') }}:
                {{ item?.scores === null ? '-' : item.scores }}/{{ item.score }}
              </div> -->

              <div class="mark-example-con">
                {{ $t('hsk_reference_answer') }} &nbsp;&nbsp;{{ item.evaluate.standard_answer[0] }}
              </div>
            </div>
            <!-- 正确 -->
            <div class="panel-content-result result-correct" v-if="item.judge == 1">
              <p class="correct-tips">
                {{ $t('textbook_chioce_word_text_correct_tip') }}
              </p>
            </div>
            <!-- 错误 -->
            <div
              class="panel-content-result result-error"
              v-if="item.judge == 0 && item.scores !== null"
            >
              <p class="error-tips">
                {{ $t('textbook_chioce_word_text_error_tip') }}
              </p>
              <div class="result-show">
                <div class="your-answer">{{ $t('hsk_your_answer') }}{{ item.myAnswerText }}</div>
                <p class="correct-answer" v-if="item.question_type != 'tk'">
                  {{ $t('hsk_correct_answer') }}{{ item.successAnswerText }}
                </p>
              </div>
            </div>
            <div class="correct-box" v-if="item.audioText || item.analysisText">
              <p class="correct-box-title" v-if="item.audioText">
                {{ $t('hsk_audio_text') }}
              </p>
              <p class="correct-box-answer" v-if="item.audioText">
                {{ item.audioText }}
              </p>
              <div v-show="item.analysisText">
                <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
                <p class="correct-box-answer">
                  {{ item.analysisText }}
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import { VOICE_EXTEND_TIME } from '@/config'

export default {
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    ansProgressStatus: {
      type: Number,
      required: false,
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 当前试题正确答案
      currCorrectAnswer: [1, 2, 3],
      // 是否已提交
      isSubmit: false,
      // 是否页面事件禁用
      isDisabled: false,
      icons: {
        play: require('@/assets/images/btn_play_hsk.png'),
        pause: require('@/assets/images/btn_pause_hsk.png'),
        playHsk: require('@/assets/images/play_hsk.png'),
      },
      changeBtn: false,
      topPlayStatus: 'play',
      noAnswerQuesIndex: 0,
      // playVoiceTime: '',
      startTime: 0,
      middleTime: 0,
      inputArr: ['', '', ''],
      newQuestionList: [],
    }
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
  },

  watch: {
    ansProgressStatus: {
      handler(val) {
        if (val == 2) {
          this.middleTime = 0
        }
      },
    },
    currItem: {
      handler(val) {
        let tkInputCount = 0
        this.newQuestionList = val.questions.map((item, index) => {
          item.analysisText = item.analysis[this.language]
            ? item.analysis[this.language]
            : item.analysis['cn']
          item.audioText = item.listen.audio_text
          if (item.question_type == 'tk') {
            // 如果存储过答案，是值，没存储过为空
            let valArr = []
            let valIndex = 0
            if (typeof this.currItem.answer == 'object') {
              valArr = this.currItem?.answer[index].split(';')
            }

            let tempArr = item.content_tk.split('（）')

            let resultArr = []
            for (let i = 0; i < tempArr.length; i++) {
              resultArr.push({
                type: 'text',
                val: tempArr[i],
              })
              if (i < tempArr.length - 1) {
                resultArr.push({
                  type: 'input',
                  val: valArr[valIndex] || '',
                  count: tkInputCount,
                })

                this.inputArr[tkInputCount] = valArr[valIndex]
                valIndex++
                tkInputCount++
              }
            }

            item.tkContentArr = resultArr
          } else {
            if (val.answer && val.answer.length > 0 && !this.changeBtn) {
              for (let i = 0; i < item.answers.length; i++) {
                if (item.answers[i].index == this.currItem.answer[index]) {
                  item.answers[i].selected = true
                  item.myAnswerText = item.answers[i].flag
                } else {
                  item.answers[i].selected = false
                }
                if (item.answers[i].correct) {
                  item.successAnswerText = item.answers[i].flag
                }
              }
            }
          }

          return item
        })
        console.log('get new questionLIst', this.newQuestionList)
        this.changeBtn = false
      },

      immediate: true,
    },
  },
  mounted() {
    this.startTime = this.$player.totalTime
    this.middleTime = this.$player.lastPlayTime
    if (this.ansProgressStatus != 1) {
      this.middleTime = 0
      return
    }
    if (!this.isExamMode) {
      !localStorage.getItem('bigIndex') && this.resetPlayStatus(this.currItem, 'pause', true)
      console.log(this.newQuestionList, 'afterResetPlayStatus')
      if (localStorage.getItem('bigIndex') == this.currItem.bigIndex) {
        this.topPlayStatus = 'pause'
      } else {
        this.topPlayStatus = 'play'
      }
      let status = this.newQuestionList.find((item) => {
        return item.playStatus == 'pause'
      })
      if (status) {
        this.topPlayStatus = 'play'
      }
    }
  },
  methods: {
    tkInputChange(e, question, index, tkItem) {
      if (question.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }

      console.log(question, 'question')
      // 如果是两个填空，组合答案传值；
      tkItem.val = e
      // 接口保存答案；
      let tkContentArr = question?.tkContentArr
      let bigIndexVal = ''
      let tkCount = 0
      tkContentArr.forEach((item) => {
        if (item.type == 'input') {
          if (tkCount == 0) {
            bigIndexVal = item.val
          } else {
            bigIndexVal = bigIndexVal + ';' + item.val
          }
          tkCount++
        }
      })
      this.$set(this.currItem.answer, index, e)
      let ansObj = {
        questionId: question.index,
        answer: bigIndexVal,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
      }
      this.$emit('saveRes', ansObj)
    },
    // 小题选项点击事件
    clickQuestionChoice(event, question, option, index) {
      // this.stopAllVoice()
      if (question.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      const isCorrect = parseInt(event.currentTarget.dataset.correct)

      question.isCorrect = isCorrect
      question.isFinished = true
      question.ansId = option.index
      question.answers.forEach((answerItem) => {
        if (answerItem.index == option.index) {
          answerItem.selected = true
        } else {
          answerItem.selected = false
        }
      })
      console.log(event, question, option, index, 'arguments')
      // 作答的对象
      let ansObj = {
        questionId: question.index,
        answer: option.index.toString(),
        judge: isCorrect,
        scores: isCorrect == 1 ? question.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
      }

      // // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
      this.newQuestionList = Object.assign({}, this.newQuestionList)
    },
    //点击播放
    clickPlayVoice(question, status, isTryAgain) {
      localStorage.removeItem('bigIndex')
      if (this.isExamMode && status) return
      this.resetPlayStatus(question, 'pause')
      this.topPlayStatus = 'play'
      let audioPath = this.baseUrl + question.listen.audio_file
      console.log('小题播放链接===', audioPath)
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.resetPlayStatus(question, 'play')
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.clickPlayVoice(question, false, true)
              layer.close(index)
            },
            btn2: (index) => {
              _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
              layer.close(index)
            },
          })
        } else {
          setTimeout(() => {
            let partData = this.$store.state.simulation.currentPart
            console.log('当前听力组件 setChoosePicByVoiceSimulation ', partData)
            if (partData.part == 'listen' && !partData.isPaused)
              _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
          }, VOICE_EXTEND_TIME * 1000)
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
      }
    },
    //点击暂停
    clickPauseVoice(question) {
      this.$player.pause()
      this.resetPlayStatus(question, 'play')
    },
    //根据状态显示播放/暂停按钮
    iconPlay(playType) {
      return this.icons[playType]
    },
    //重置播放状态
    resetPlayStatus(question, status, isclickStatus) {
      console.log(this.newQuestionList, 'resetPlayStatus')
      if (this.newQuestionList.length > 0) {
        let questions = this.newQuestionList.map((item) => {
          console.log(this.currItem)
          let finallyStatus
          if (isclickStatus) {
            finallyStatus =
              item.index === question.currentPlayIndex &&
              this.currItem.bigIndex == question.currentPlayBigIndex
          } else {
            finallyStatus = item.index === question.index
          }
          if (finallyStatus) {
            item.playStatus = status
            console.log(item.playStatus)
            return item
          } else {
            item.playStatus = 'play'
            return {
              ...item,
            }
          }
        })

        this.newQuestionList = questions
      }
    },
    autoPlay(obj, status) {
      this.middleTime = 0
      if (status) {
        this.clickPlayTopVoice()
      } else {
        this.clickPlayVoice(obj)
      }
    },
    //停止全部音频，图标都恢复原来的未播放状态
    stopAllVoice() {
      this.currItem.questions.forEach((question) => {
        question.playStatus = 'play'
      })
      this.$player.stop()
    },
    //点击播放顶部录音
    clickPlayTopVoice(status, isTryAgain) {
      if (this.isExamMode && status) return
      this.newQuestionList.forEach((question) => {
        question.playStatus = 'play'
      })
      this.topPlayStatus = 'pause'
      let audioPath = this.baseUrl + this.currItem.top_listen.audio_file
      console.log('题干播放链接===', audioPath)
      this.$player.play(audioPath, '', {}, isTryAgain)
      const _this = this
      this.$player.onended = (e) => {
        this.topPlayStatus = 'play'
        if (e == 'failed') {
          layer.open({
            title: '',
            closeBtn: 0,
            content: _this.$t('common_video_failed'),
            btn: [_this.$t('button_common_start_over'), _this.$t('hsk_skip')],
            yes: (index) => {
              _this.clickPlayTopVoice(false, true)
              layer.close(index)
            },
            btn2: (index) => {
              _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
              layer.close(index)
            },
          })
        } else {
          _this.isExamMode && _this.HSKVoice('HSKVoice', Date.parse(new Date()))
        }
      }
      this.$player.onloaded = (e) => {
        this.startTime = e
        this.middleTime = e
      }
      localStorage.setItem('bigIndex', this.currItem.bigIndex)
    },
    //点击暂停顶部录音
    clickPauseTopVoice() {
      this.topPlayStatus = 'play'
      this.$player.pause()
    },
  },
  components: {
    QuestionDescription,
  },
}
</script>

<style lang="scss" scoped>
.set-choose-input-voice-root {
}
.common-panel {
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .panel-content {
    min-height: 540px;

    // 选项列表
    &-options {
      padding: 30px 30px 30px 30px;
      display: flex;
      justify-content: center;
      .stem-index {
        width: 22px;
        margin-right: 7px;
        color: #c4c9d3;
      }
      .question-options-item {
        width: 195px;
        height: 110px;
        margin-bottom: 20px;
        margin-right: 30px;
        border-radius: 5px;
        position: relative;

        .item-key {
          width: 46px;
          height: 27px;
          line-height: 27px;
          text-align: center;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 4px 0px 4px 0px;
          position: absolute;
          top: 0px;
          left: 0px;
        }
        .item-content {
          img {
            width: 195px;
            height: 110px;
            border-radius: 5px;
            object-fit: contain;
          }
        }
      }
    }

    // 套题详情
    &-details {
      padding: 0 30px;
      .question-item-stem {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin: 16px 0;
        position: relative;
        .stem-index-yellow {
          background: #3f4651;
          border-radius: 4px;
          color: #fff;
          padding: 5px;
          font-size: 12px;

          min-width: 20px;
          display: flex;
          justify-content: center;
          margin-right: 8px;
        }
        .stem-text {
          color: #2c2f46;
          font-size: 14px;
          padding-top: 2px;
        }
      }
      .question-item {
        padding: 20px 0;
        border-top: 1px solid #f2f3f7;
        position: relative;
        &-flex {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        &-stem {
          .stem-index {
            min-width: 22px;
            margin-right: 7px;
            color: #c4c9d3;
          }
          .stem-content {
            width: 40px;
            position: relative;
            img {
              width: 40px;
              height: 40px;
              cursor: pointer;
              position: absolute;
              top: -24px;
              left: 0;
            }
          }
        }
        .item-answer {
          cursor: pointer;
          position: relative;

          display: flex;
          flex-direction: column;
          justify-content: center;

          padding-left: 40px;
          width: 316px;
          min-height: 39px;
          padding: 10px 10px 10px 40px;
          font-size: 15px;
          margin-top: 10px;

          color: rgba(63, 70, 81, 1);
          background: rgba(242, 243, 247, 1);
          border-radius: 5px;
          box-sizing: border-box;

          .item-key {
            position: absolute;
            font-size: 15px;
            font-weight: 600;
            color: rgba(174, 186, 198, 1);
            top: 10px;
            left: 16px;
          }
          p {
            color: #3e4651;
            font-size: 15px;
          }
          &:after {
            position: absolute;
            content: '';
            width: 16px;
            height: 16px;
            right: -24px;
            top: 50%;
            transform: translateY(-50%);
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: cover;
          }
          &.selected {
            border: 2px solid #faae56;
            background: #ffffff;
          }
          &.success {
            background: #ffffff; // 设置白色背景
            border: 1px solid rgba(9, 203, 160, 1);
            p {
              color: #09cba0;
            }
          }

          &.error {
            background: #ffffff;
            border: 1px solid #fc5a5a;
            p {
              color: #fc5a5a;
            }
          }
        }
      }
    }

    .tk-con {
      display: flex;
      align-items: baseline;
      flex: 1;
      flex-wrap: wrap;
      .tk-text {
        margin: 0 4px;
        font-size: 14px;
        color: #2c2f46;
      }
      .tk-input {
        width: 190px;
        margin-bottom: 5px;
      }

      .tk-input-result {
        border-radius: 3px;
        border: 1px solid #ddd;
        padding: 6px 15px;
        height: 34px;
        min-width: 65px;
        margin-bottom: 5px;
      }
      .tkSuccess {
        color: #09cba0;
      }
      .tkError {
        color: #fc5a5a;
      }
    }
    .mark-score-con {
      position: absolute;
      top: 10px;
      right: 0;
      font-size: 14px;
      margin-bottom: 14px;
    }

    .mark-example-con {
      color: #09cba0;
      font-size: 14px;
      margin-bottom: 14px;
    }

    // 结果
    &-result {
      padding-top: 20px;

      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            margin-bottom: 10px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
